// extracted by mini-css-extract-plugin
export default {"NameSource":"DeleteSourceModal_NameSource__Eb11C"};